import React from "react";
import styled, { keyframes } from "styled-components";
import { useSwipeable } from "react-swipeable";

interface FlyoutProps {
  isOpen: boolean;
  title: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const Flyout: React.FC<FlyoutProps> = ({ isOpen, children, title, onClose }) => {
  const handleSwipedDown = useSwipeable({
    onSwipedDown: () => onClose(),
    swipeDuration: 1000,
    preventScrollOnSwipe: true,
  });

  return (
    <FlyoutContainer $isOpen={isOpen}>
      <FlyoutSwipable {...handleSwipedDown} onClick={onClose}>
        <HandlerLine />
        <Title>{title}</Title>
      </FlyoutSwipable>
      <FlyoutScrollable>
        {children}
        <BottomSpacer />
      </FlyoutScrollable>
    </FlyoutContainer>
  );
};

const Title = styled.h2`
  display: block;
  color: ${({ theme }) => theme.buttonTextColor};
  margin-top: 20px;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
`;

const FlyoutScrollable = styled.div`
  height: 100%;
  overflow-y: scroll;
  padding: 10px 20px;
`;

const FlyoutSwipable = styled.div`
  width: 100%;
  padding: 20px 0;
  background: linear-gradient(to top, ${({ theme }) => theme.buttonBgColor}, rgba(255, 255, 255, 0));
`;

const HandlerLine = styled.div`
  diplay: block;
  width: 120px;
  height: 4px;
  background-color: #ccc;
  margin: 0 auto;
  border: none;
`;

const slideUpAnimation = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const FlyoutContainer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${({ $isOpen }) => ($isOpen ? "99vh" : "0")};
  background-color: white;
  border-radius: 25px 25px 0 0;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  transition: height 0.3s ease-in-out;
  animation: ${slideUpAnimation} 0.7s ease-in-out;
  background-color: ${({ theme }) => theme.buttonBgColor};
`;

const BottomSpacer = styled.div`
  width: 100%;
  height: 220px;
  background-color: transparent;
`;

export default Flyout;
